import * as React from "react";

import { telemetryService } from "../../modules/telemetry.service";
import { useRouter } from "../hooks";

export const RouteTracker = () => {
    const {
        location: { pathname, search },
    } = useRouter();

    React.useEffect(() => {
        let url = pathname;
        if (!!search) {
            url += search;
        }

        telemetryService.trackRoute(pathname, url);
    }, [pathname, search]);

    return null;
};
